<template>
  <div id="invoice-resolve-redirect-page">
    <vs-alert color="danger" :title="$t('InvoiceGroupNotifyTitle')" :active.sync="error">
      <span v-html="error"></span>
    </vs-alert>
  </div>
</template>

<script>
import Vue from "vue";
import InvoiceApi from "@/api/invoice";
import { VueReCaptcha } from "vue-recaptcha-v3";

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_GOOGLE_CAPTCHA });

export default {
  components: {},
  data() {
    return {
      error: null
    };
  },
  methods: { 
  },
  async mounted(){
    this.$vs.loading({
        color: "#000",
        scale: 0.45
      });

      const token = this.$route.params.token;

      var resolveResult = await InvoiceApi.resolveStudent(
        { Token: token.toString() },
        this
      );

      if (!resolveResult.data.error && !resolveResult.data.errors) {  
        this.$auth.localLogin(resolveResult.data.Student);
        this.$router.push({
          name: "payment"
        });
      } 
      else 
        this.error = resolveResult.data.error ? resolveResult.data.error : (resolveResult.data.errors ? "<ul><li>- " + Object.values(resolveResult.data.errors)[0].join('<li>- ') + "</ul>" : "");

      setTimeout(() => {
        this.$vs.loading.close();
      }, 100);
  }
};
</script>